import { Button, InlineStack, Page, Select } from "@shopify/polaris";
import { t, tInitialize } from "../../query/share";
import { baseType } from "../hooks/base";
import { authAxios } from "../Types";
import { modalsType } from "../hooks/modals";
import { EmailIcon } from "@shopify/polaris-icons";

const TopHeader = (props: baseType & authAxios & modalsType) => {
  const { changeBase, base, changeModals } = props;
  return (
    <Page>
      <InlineStack align="space-between">
        <InlineStack gap="200">{/* <Save {...props} /> */}</InlineStack>
        <InlineStack>
          <Select
            options={[
              { label: "日本語", value: "ja" },
              { label: "English", value: "en" },
            ]}
            label=""
            labelHidden
            onChange={(value) => {
              tInitialize(value);
              changeBase({ lang: value });
            }}
            value={base.lang}
          />
          <Button
            onClick={() => {
              changeModals({
                open: true,
                title: t("お問い合わせ", "Contact"),
                message: t(
                  "miyakocastle@gmail.com までお気軽にお問い合わせください。",
                  "Please feel free to contact us at miyakocastle@gmail.com."
                ),
              });
            }}
            icon={EmailIcon}
          >
            {t("お問合せ", "Contact")}
          </Button>
        </InlineStack>
      </InlineStack>
    </Page>
  );
};

export default TopHeader;
